import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT_APP } from 'store/sagas'

export const NAMESPACE = 'KanBo/notifications/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const SET_LAST_LOADED_ID = NAMESPACE + 'SET_LAST_LOADED_ID'
export const SET_UNREAD_COUNT = NAMESPACE + 'SET_UNREAD_COUNT'
export const INCREASE_UNREAD_COUNT = NAMESPACE + 'INCREASE_UNREAD_COUNT'
export const DECREASE_UNREAD_COUNT = NAMESPACE + 'DECREASE_UNREAD_COUNT'
export const SET_UNREAD_ONLY = NAMESPACE + 'SET_UNREAD_ONLY'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const SET_ARRAY = NAMESPACE + 'SET_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_WAS_READ = NAMESPACE + 'SET_WAS_READ'
export const SET_CARD_COUNTS = NAMESPACE + 'SET_CARD_COUNTS'

const initialState = {
  notifications: [],
  notificationsById: {},
  countsByCardId: {},
  lastLoadedId: null,
  isLoading: false,
  isLoaded: false,
  unreadCount: 0,
  unreadOnly: true
}

const notificationDefaults = {

}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT_APP:
      return {
        ...initialState
      }
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case SET_LAST_LOADED_ID:
      return {
        ...state,
        lastLoadedId: action.payload.lastLoadedId
      }
    case SET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: action.payload.unreadCount
      }
    case INCREASE_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: state.unreadCount + action.payload.unreadCount
      }
    case DECREASE_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: state.unreadCount - action.payload.unreadCount
      }
    case SET_UNREAD_ONLY:
      return state.unreadOnly === action.payload ? state : {
        ...initialState,
        unreadCount: state.unreadCount,
        unreadOnly: action.payload
      }
    case ADD:
      return {
        ...state,
        notifications: addUniqueValueToArray({
          array: state.notifications,
          value: action.payload.id,
          index: action.payload.index
        }),
        notificationsById: {
          ...state.notificationsById,
          [action.payload.id]: {
            ...notificationDefaults,
            ...action.payload
          }
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        notifications: [ ...state.notifications ],
        notificationsById: { ...state.notificationsById }
      }
      action.payload.forEach(notification => {
        newState.notifications = addUniqueValueToArray({
          array: newState.notifications,
          value: notification.id,
          index: notification.index
        })
        newState.notificationsById[notification.id] = {
          ...notificationDefaults,
          ...notification
        }
      })
      return newState
    }
    case SET_ARRAY: {
      const newState = {
        ...state,
        notifications: [ ...state.notifications ],
        notificationsById: { ...state.notificationsById }
      }
      action.payload.forEach(notification => {
        if (newState.notificationsById[notification.id]) {
          newState.notificationsById[notification.id] = {
            ...newState.notificationsById[notification.id],
            ...notification
          }
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        notifications: [ ...state.notifications.filter(id => id !== action.payload.id) ],
        notificationsById: { ...state.notificationsById }
      }
      delete newState.notificationsById[action.payload.id]
      return newState
    }
    case SET_WAS_READ:
      return state.notificationsById[action.payload.id] ? {
        ...state,
        notificationsById: {
          ...state.notificationsById,
          [action.payload.id]: {
            ...state.notificationsById[action.payload.id],
            wasRead: action.payload.wasRead
          }
        }
      } : state
    case SET_CARD_COUNTS:
      return {
        ...state,
        countsByCardId: action.payload.countsByCardId
      }
    default: return state
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function setLastLoadedId ({ lastLoadedId }) {
  return {
    type: SET_LAST_LOADED_ID,
    payload: {
      lastLoadedId
    }
  }
}

export function setUnreadCount ({ unreadCount }) {
  return {
    type: SET_UNREAD_COUNT,
    payload: {
      unreadCount
    }
  }
}

export function increaseUnreadCount ({ unreadCount }) {
  return {
    type: INCREASE_UNREAD_COUNT,
    payload: {
      unreadCount
    }
  }
}
export function decreaseUnreadCount ({ unreadCount }) {
  return {
    type: DECREASE_UNREAD_COUNT,
    payload: {
      unreadCount
    }
  }
}

export function setUnreadOnly (payload) {
  return {
    type: SET_UNREAD_ONLY,
    payload
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (array) {
  return {
    type: ADD_ARRAY,
    payload: array
  }
}

export function setArray (array) {
  return {
    type: SET_ARRAY,
    payload: array
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setWasRead ({ id, wasRead }) {
  return {
    type: SET_WAS_READ,
    payload: {
      id,
      wasRead
    }
  }
}

export function setCardCounts ({ countsByCardId }) {
  return {
    type: SET_CARD_COUNTS,
    payload: {
      countsByCardId
    }
  }
}
